import requiredBaseValidator from './required';

export default requiredBaseValidator;
